import { render, staticRenderFns } from "./LikedBooks.vue?vue&type=template&id=1dec6bf2&"
import script from "./LikedBooks.vue?vue&type=script&lang=js&"
export * from "./LikedBooks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports